import React, { useState, useCallback } from 'react';
import {
  ReactFlow,
  Background,
  Controls,
  Panel,
  useNodesState,
  useEdgesState,
  addEdge,
  useReactFlow
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';

const getNodeId = () => `node_${+new Date()}`;

export function ReactFlowDiagram({
  initialNodes = [],
  initialEdges = [],
  onNodesChange: externalOnNodesChange,
  onEdgesChange: externalOnEdgesChange,
  height = '500px',
  className = ''
}) {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [rfInstance, setRfInstance] = useState(null);

  // Callback para conectar nodos
  const onConnect = useCallback(
    (params) => {
      setEdges((eds) => addEdge(params, eds));
      // Notificar a Ember
      if (externalOnEdgesChange) {
        externalOnEdgesChange([{ type: 'add', item: params }], edges);
      }
    },
    [setEdges, externalOnEdgesChange, edges]
  );

  const onAddNode = useCallback(() => {
    const newNode = {
      id: getNodeId(),
      data: { label: `Nodo ${nodes.length + 1}` },
      position: {
        x: Math.random() * 300,
        y: Math.random() * 300,
      },
    };
    setNodes((nds) => nds.concat(newNode));

    // Notificar a Ember
    if (externalOnNodesChange) {
      externalOnNodesChange([{ type: 'add', item: newNode }], [...nodes, newNode]);
    }
  }, [setNodes, nodes, externalOnNodesChange]);

  const onClear = useCallback(() => {
    setNodes([]);
    setEdges([]);

    // Notificar a Ember
    if (externalOnNodesChange) {
      externalOnNodesChange([{ type: 'reset' }], []);
    }
    if (externalOnEdgesChange) {
      externalOnEdgesChange([{ type: 'reset' }], []);
    }
  }, [setNodes, setEdges, externalOnNodesChange, externalOnEdgesChange]);

  const onSave = useCallback(() => {
    if (rfInstance) {
      const flow = rfInstance.toObject();
      console.log('Flow:', flow);

      // Emitir evento personalizado que Ember puede escuchar
      const event = new CustomEvent('react-flow-save', {
        detail: { nodes, edges, flow }
      });
      window.dispatchEvent(event);
    }
  }, [rfInstance, nodes, edges]);

  return (
    <div className={`react-flow-container ${className}`} style={{ width: '100%', height }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onInit={setRfInstance}
        fitView
        fitViewOptions={{ padding: 0.1 }}
        nodesDraggable={true}
        nodesConnectable={true}
        elementsSelectable={true}
      >
        <Background variant="dots" gap={12} size={1} />
        <Controls />

        <Panel position="top-right" className="space-x-2">
          <button
            className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
            onClick={onAddNode}
          >
            Añadir
          </button>
          <button
            className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 text-sm"
            onClick={onSave}
          >
            Guardar
          </button>
          <button
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
            onClick={onClear}
          >
            Limpiar
          </button>
        </Panel>
      </ReactFlow>
    </div>
  );
}